import { render, staticRenderFns } from "./MultipleChoiceComponent.vue?vue&type=template&id=6c4a7fb2&"
import script from "./MultipleChoiceComponent.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VAutocomplete,VCard,VCombobox})
